module.exports = __webpack_public_path__ + "img/mitsubishi.b138db45.svg";